import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlternateEmailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alternate_email"}/>
}
